const LanguageName = (props) => {
  switch (props.locale) {
    case 'en': return props.localize('Common.English')
    case 'ar': return props.localize('Common.Arabic')
    default: return '---'
  }
}

export default LanguageName



// WEBPACK FOOTER //
// ./src/components/LanguageName.js